// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getMerchant, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getMoneyFormat } from '@tectonics/look-and-feel/volcanes/commons/money-format';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { useCurrentReceipt } from '@tectonics/prs/receipts';
import { getReceiptAmountExt } from '@tectonics/prs/receipts/receipt';
import { shouldRedirect } from '@tectonics/prs/incoming-payment/should-redirect';
import { getName as getMerchantName } from '@tectonics/prs/merchant';

export function Header(): Node {
  const incomingPayment = useIncomingPayment();
  const decimalFormat = getMoneyFormat(incomingPayment.country);
  const formatAmount = amountToCurrencyString(decimalFormat);
  const receipt = useCurrentReceipt();
  const merchant = getMerchant(incomingPayment);
  const merchantName = getMerchantName(merchant);
  const pageIsBeingRedirected = shouldRedirect(incomingPayment);

  return (
    <Root>
      {pageIsBeingRedirected ? (
        <PaymentConfirmedMessage>
          Está siendo redirigido a {merchantName}
        </PaymentConfirmedMessage>
      ) : (
        <PaymentConfirmedMessage>
          Tu pago de <PaymentConfirmedAmount>{formatAmount(getReceiptAmountExt(receipt))}</PaymentConfirmedAmount> fue aprobado \o/
        </PaymentConfirmedMessage>
      )
      }
    </Root>
  );
}

const Root = styled.div`
  font-family: ${props => props.theme.fontFamily.display};
  line-height: 1.5;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
`;

const PaymentConfirmedMessage = styled.div`
  font-size: 25px;
  margin: 15px 0;
  font-weight: 400;
  color: ${props => props.theme.colors.black[0]};
`;

const PaymentConfirmedAmount = styled.strong`
  color: ${props => props.theme.colors.new_primary[600]};
`;
